module.exports = __webpack_public_path__ + "img/LOVAL-Logo_old.fbf4c716.svg";